module.exports = __webpack_public_path__ + "static/media/ImporterFeatureIcon5.f4403ed0.svg";